import { encrypt } from "./tokenizer";

export function getCookie(name) { 
    const re = new RegExp(name + "=([^;]+)"); 
    const value = re.exec(document.cookie); 
    return (value != null) ? unescape(value[1]) : null; 
}

export function removeCookies( name ) {
    console.log(name)
    document.cookie = name+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export function setEncryptedCookie(name = "", value = "") {
    if(name != "" && value != ""){
        document.cookie = `${name} =${encrypt(value)}`;
    } 
}

export function checkSSOStatus() {
  return localStorage.getItem("ssoCompleted") === "true";
}